import { useEffect } from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';
import { useSocialMode } from './social-mode-context';

export function SocialModeSync() {
  const [searchParams] = useSearchParams();
  const { enableSocialMode, setIntent } = useSocialMode();
  const socialParam = searchParams.get('social');
  const queryIntent = searchParams.get('intent');
  const hasIntent = searchParams.has('intent');

  useEffect(() => {
    if (socialParam === 'true') {
      enableSocialMode();
      if (hasIntent) setIntent(queryIntent);
    }
  }, [socialParam, hasIntent, queryIntent, enableSocialMode, setIntent]);

  return <Outlet />;
}
